import * as glMatrix from 'gl-matrix'
import { Point } from '../math/point'
import { fromTranslate } from '../math/transform'
import { Rectangle } from '../math/rectangle'
import { Size } from '../math/size'

export class Viewport {
  constructor(readonly length: number, readonly origin: Point) {}

  rectangle(): Rectangle {
    return new Rectangle(this.origin, new Size(this.length))
  }
}

export class ViewTransform {
  // relative: translate using world origin
  constructor(readonly screenViewport: Viewport) {}

  screenToWorld(worldViewport: Viewport, relative: boolean = true): glMatrix.mat2d {
    const transform = screenToWorld(this.screenViewport, worldViewport)

    if (relative) {
      const translate = fromTranslate(worldViewport.origin)
      glMatrix.mat2d.multiply(transform, translate, transform)
    }

    return transform
  }

  worldToScreen(worldViewport: Viewport, relative: boolean = true): glMatrix.mat2d {
    const transform = worldToScreen(worldViewport, this.screenViewport)

    if (relative) {
      const translate = fromTranslate(worldViewport.origin.negate())
      glMatrix.mat2d.multiply(transform, transform, translate)
    }

    return transform
  }

  worldToScreenScalar(scalar: number, worldViewport: Viewport): number {
    const viewportScale = this.screenViewport.length / worldViewport.length
    return scalar * viewportScale
  }
}

function worldViewToViewport(worldViewport: Viewport, viewport: Viewport): glMatrix.mat2d {
  const viewportScale = viewport.length / worldViewport.length
  const halfViewportLength = viewport.length / 2

  return glMatrix.mat2d.fromValues(viewportScale, 0, 0, -viewportScale, halfViewportLength, halfViewportLength)
}

function worldToScreen(worldViewport: Viewport, viewport: Viewport): glMatrix.mat2d {
  const transform = worldViewToViewport(worldViewport, viewport)

  const translate = fromTranslate(viewport.origin)
  glMatrix.mat2d.multiply(transform, translate, transform)

  return transform
}

function viewportToWorldView(viewport: Viewport, worldViewport: Viewport): glMatrix.mat2d {
  const gridScale = worldViewport.length / viewport.length
  const halfGridLength = worldViewport.length / 2

  return glMatrix.mat2d.fromValues(gridScale, 0, 0, -gridScale, -halfGridLength, halfGridLength)
}

function screenToWorld(viewport: Viewport, worldViewport: Viewport): glMatrix.mat2d {
  const translate = fromTranslate(viewport.origin.negate())
  const transform = viewportToWorldView(viewport, worldViewport)

  glMatrix.mat2d.multiply(transform, transform, translate)

  return transform
}
